export default __webpack_public_path__ + "static/media/surprised.f8837df6.png";